<template>
  <div class="sourceUrls">
    <div class="sourceUrls-url"
      v-for="item in items"
      :key="item.url"
    >
      <div class="sourceUrls-url-icon">
        <img :src="item.icon"
          alt="url icon"
          :onerror="`if (this.src != '${fallbackIcon}') this.src = '${fallbackIcon}';`"
        />
      </div>

      <div class="sourceUrls-url-link">
        <a :href="item.url"
          target="_blank"
          rel="noopener noreferrer"
          :title="item.url"
        >
          {{ formatLinkText(item.url) }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import fallbackIcon from '../../assets/images/toggle-box-images/web.svg'

export default {
  name: 'SourceUrls',

  props: {
    /**
     * Array of items in the with the follwing properties:
     * - icon: Link to the url icon
     * - url: the url itself
     */
    items: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    fallbackIcon
  }),

  methods: {
    formatLinkText (link) {
      return link.length > 32
        ? `${link.substring(0, 32)}...`
        : link
    }
  }
}
</script>

<style lang="scss">
.sourceUrls {
  box-sizing: border-box;
  overflow: hidden;

  &-url {
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 5px 0;

    &-icon {
      box-sizing: border-box;
      overflow: hidden;
      width: 20px;
      height: 20px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    &-link {
      padding: 0 0 0 5px;
    }
  }
}
</style>
